import { Platform, Orientation } from "consts";
import { maxWidth } from "utils";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "75%",
    [Orientation.LANDSCAPE]: "53%",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "95%",
  },
};

export const CheckBoxSpacing = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: width => (width - 170) / 2,
    [Orientation.LANDSCAPE]: width => (width - 280) / 2,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: width => width - 40,
    [Orientation.LANDSCAPE]: width => (width - 120) / 2,
  },
};

export const CheckBoxMargin = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "21",
    [Orientation.LANDSCAPE]: "21",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "10",
    [Orientation.LANDSCAPE]: "10",
  },
};

export const CheckboxWrapperPadding = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "4px 5px",
  },
};

export const CheckBoxSize = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "25",
    [Orientation.LANDSCAPE]: "25",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "21",
    [Orientation.LANDSCAPE]: "21",
  },
};

export const CheckedImageHeight = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "15",
    [Orientation.LANDSCAPE]: "15",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "15",
    [Orientation.LANDSCAPE]: "21",
  },
};

export const CheckedImageWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "14",
    [Orientation.LANDSCAPE]: "16",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "13",
    [Orientation.LANDSCAPE]: "21",
  },
};

export const LabelFontSize = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: "16",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: 15,
  },
};
